import React, { useEffect, useState } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import MetPolicelogo from '../../assets/images/met-police-logo-outlined.svg';

function Module21() {

  const { setCanContinue } = usePageControl();

  useEffect(() => {
    setCanContinue(false);
  }, [setCanContinue]);

 // Timer
const { totalTime, formatTime } = useTimer();



  return (
    <div id="module-21" className="page physical">

    {/* -- Background animation -- */}
    {/* 
    <div id="anim-dots-1" className="anim-dots"></div>
    <div id="anim-dots-2" className="anim-dots"></div>
    <div id="anim-dots-3" className="anim-dots"></div>
    <div id="anim-dots-4" className="anim-dots"></div>
    <div id="anim-dots-5" className="anim-dots"></div>
    <div id="anim-dots-6" className="anim-dots"></div> */}

      <header className="container-fluid">
        <div className="row">
          <div className="col-12">
            
          </div>
        </div>
      </header>

      <main className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div id="box-wrapper-end">

              <img src={MetPolicelogo} className="met-police-logo img-fluid" alt="Metropolitan Police logo"/>
              <h1>Cyber Escape Room</h1>

              <p>Congratulations on completing the Cyber Escape Room!</p>

              <p><strong>You finished it in: {formatTime(totalTime)}</strong></p>

              <p>Please leave this screen up for an administrator to note your time down.</p>
            </div>
          </div>
        </div>
      </main>

      <footer className="container-fluid">
        <div className="row">
          <div className="col-12">
            <PageNavigation />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Module21;
